import clsx from 'clsx';

import { RadioGroup } from '@atom/mui';
import { WorkOrderTypeOption } from '@atom/types/work';

import classes from './workTemplateCreationModal.module.css';

const { RadioButton } = RadioGroup;

interface Props {
  option: WorkOrderTypeOption;
  selected: boolean;
  onClick: (value: any) => void;
}

const RadioButtonRow = ({ option, selected, onClick }: Props) => {
  return (
    <div
      className={clsx(classes.radioButtonRow, selected && classes.selected)}
      onClick={() => onClick(option.value)}
    >
      <RadioButton
        onChange={event => onClick(event.target.value)}
        value={option.value}
        checked={selected}
        label={
          <div className={classes.radioButtonLabel}>
            <img className={classes.radioButtonRowIcon} src={option.icon} />
            <div>
              <div className={classes.radioButtonRowTitle}>{option.title}</div>
              <div className={classes.radioButtonRowSubtext}>
                {option.subtext}
              </div>
            </div>
          </div>
        }
      />
    </div>
  );
};

export default RadioButtonRow;
